import React from 'react'
import NestedPageHero from '../NestedPageHero'
import FamilyRoom from '../FamilyRoom'
import ExclusiveOffers from '../ExclusiveOffers';

function BedSpace() {
  const roomsData = [
    {
      roomName: "Junior Suite",
      description:
        "Spacious, bright guestrooms with tasteful furnishing, wooden floor and panoramic windows from the ceiling to the floor.",
      images:["/images/d.jpg", "/images/e.jpg", "/images/f.jpg"],
      price: 150,
      capacity: "1-2",
      bedType: "Twin Bed",
      area: 200,
      breakfast: true,
    },
    {
      roomName: "Double Room",
      description:
        "Spacious, bright guestrooms with tasteful furnishing, wooden floor and panoramic windows from the ceiling to the floor.",
      images: ["/images/d.jpg", "/images/e.jpg", "/images/f.jpg"],
      price: 250,
      capacity: "2-3",
      bedType: "Twin Bed",
      area: 280,
      breakfast: true,
    },
    {
      roomName: "Deluxe Room",
      description:
        "Spacious, bright guestrooms with tasteful furnishing, wooden floor and panoramic windows from the ceiling to the floor.",
      images: ["/images/d.jpg", "/images/e.jpg", "/images/f.jpg"],
      price: 300,
      capacity: "4-5",
      bedType: "Twin Bed",
      area: 300,
      wifi: true,
    },
    {
      roomName: "Luxury Suite",
      description:
        "Spacious, bright guestrooms with elegant furniture and stunning views.",
      images: ["/images/d.jpg", "/images/e.jpg", "/images/f.jpg"],
      price: 350,
      capacity: "3-4",
      bedType: "King Bed",
      area: 300,
      wifi: true,
    }
  ];

  return (
    <div>
      <NestedPageHero title={'Bed Space'} />
      
      {/* Loop through roomsData and render FamilyRoom for each room */}
      {roomsData.map((room, index) => (
        <FamilyRoom
          key={index}
          roomName={room.roomName}
          description={room.description}
          images={room.images}
          price={room.price}
          capacity={room.capacity}
          bedType={room.bedType}
          area={room.area}
          wifi={room.wifi}
          roomIndex={index + 1}
        />
      ))}
      <ExclusiveOffers/>
    </div>
  )
}

export default BedSpace
